
const sortableProductsTableColumns = {
    name: "name",
    sku: "sku",
    barcode: "barcode",
    active: "active",
    isAmazon: "isAmazon",
    isBundle: "isBundle",
    productCategory: "productCategory"
};

const sortableVendorTableColumns = {
    vendorId: "sh_legacy_id",
    name: "vendor_name",
    emails: "email",
    accountNumber: "account_number",
};

const sortablePurchaseOrdersTableColumns = {
    poNumber: "po_number",
    poDate: "po_date",
    vendorName: "vendor_name",
};

module.exports = {
    sortableProductsTableColumns,
    sortableVendorTableColumns,
    sortablePurchaseOrdersTableColumns
}
